/**
 * Retrieve RTCStatsReport for a sender or the peerConnection.
 * @method getStats
 * @param {string} [TrackId] Return stats for peerConnection if trackId is not provided
 * @return {Promise} Resolves with the RTCStatsReport
 */
export default function getStats (trackId) {
  const { nativePeer, proxyPeer, log } = this
  log.info(`Getting stats ${trackId ? 'for track.' : '.'}`)
  // If no trackId is supplied, get the stats from the RTCPeerConnection. Otherwise, find an RTCSender
  // associated with the trackId and get the stats from it.

  // Use the trackId if it was provided
  if (trackId) {
    return new Promise((resolve, reject) => {
      const senders = proxyPeer.getSenders()
      // search for a sender associated with the trackId
      const sender = senders.find(sender => sender.track.id === trackId)
      if (sender) {
        sender
          .getStats()
          .then(resolve)
          .catch(reject)
      } else {
        const errMsg = `Cannot find sender with trackId: ${trackId}`
        log.info(errMsg)
        reject(new Error(errMsg))
      }
    })
  } else {
    // get the stats associated with the peerConnection if no trackId is supplied
    return nativePeer.getStats()
  }
}
